import React, { createContext, useReducer } from 'react';

const initialGlobalState = {

  customValue: "old value in global store",
  TOGGLE_TERM_CONDITION_MODAL: false,
  TOGGLE_PAYROLL_MODAL: false,
  TOGGLE_UPGRADE_SUBSCRIPTION: false
};

const reducer = (state, action) => {
  switch (action.type) {

    case 'ADDVALUE': {
      return {
        ...state,
        customValue: "demo value for global context"
      };
    }
    case 'MODAL_OFF': {
      console.log(action.payload)
      return {
        ...state,
        [action.payload]: false
      };
    }
    case 'MODAL_ON': {
      return {
        ...state,
        [action.payload]: true
      };
    }
    case 'TOGGLE_MODAL': {
      if (action.payload === 'TOGGLE_TERM_CONDITION_MODAL') {
        return {
          ...state,
          [action.payload]: !state.TOGGLE_TERM_CONDITION_MODAL,
        }
      }
      if (action.payload === 'TOGGLE_PAYROLL_MODAL') {
        return {
          ...state,
          [action.payload]: !state.TOGGLE_PAYROLL_MODAL,
        }
      }
      if (action.payload === 'TOGGLE_UPGRADE_SUBSCRIPTION') {
        return {
          ...state,
          [action.payload]: !state.TOGGLE_UPGRADE_SUBSCRIPTION,
        }
      }
    }
    default: {
      return { ...state };
    }
  }
};

const GlobalContext = createContext({
  ...initialGlobalState,
  addValMethod: () => { console.log('Add Value') },
  toggleForModal: () => { console.log('Modal') },
  offForModal: () => { console.log('Modal off') },
  openForModal: () => { console.log('Modal on') },

});
export const GlobalStoreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialGlobalState);

  const addValMethod = (payload) => {
    dispatch({ type: 'ADDVALUE', payload: payload });
  };
  const toggleForModal = (payload) => {
    dispatch({ type: 'TOGGLE_MODAL', payload: payload });
  };
  const offForModal = (payload) => {
    dispatch({ type: 'MODAL_OFF', payload: payload });
  };
  const openForModal = (payload) => {
    dispatch({ type: 'MODAL_ON', payload: payload });
  };

  return (
    <GlobalContext.Provider
      value={{
        ...state,
        addValMethod,
        toggleForModal,
        offForModal,
        openForModal,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;
